import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CustomersType } from '@cargos/sprintpay-models';
import { Observable, catchError, distinctUntilChanged, map, of, take } from 'rxjs';
import { CustomerService } from '../services';

@Injectable({
    providedIn: 'root',
})
export class CustomerTypeGuard {
    constructor(
        private customerService: CustomerService,
        private router: Router
    ) {}

    getUserProfile(): Observable<CustomersType | undefined> {
        return this.customerService.getCustomerType().pipe(distinctUntilChanged());
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.getUserProfile().pipe(
            take(1),
            map((profile) => {
                if (route.data['expectedCustomerTypes'].includes(profile)) {
                    return true;
                }

                this.router.navigate(['./']);
                return false;
            }),
            catchError(() => {
                this.router.navigate(['./']);
                return of(false);
            })
        );
    }
}
